/*
|====================================== GETTING DATE ================================|
|===========================      getDate (queryKey)           ======================|
|====================================================================================|
|   Arguments:
|    - queryKey - according to 'queryKey' we decide with date should be returned to user
|
|   Return:
|   - date in miliseconds
|   
|==================================================================================|
*/
import add from "date-fns/add/index.js";
import setDay from "date-fns/setDay/index.js";
import isSameWeek from "date-fns/isSameWeek/index.js";

//********************** POPULATE WITH DATE ************************//
export function populateWithDate(items, model) {
  items.forEach((item) => {
    model.forEach((modelField) => {
      let field = item.fields.find(
        (sourceField) => sourceField.element_id == modelField.element_id
      );
      if (field) {
        if (modelField.data_range) {
          if(modelField.date_type.includes('calendar')) {
            field.field_value = `${getStartDate(modelField.date_type)}:${getDate(modelField.date_type)}`
          } else {
            field.field_value = `${getStartDate(modelField.date_type)}:${getDate(modelField.date_type)}`
          }
        } else {
           field.field_value = getDate(modelField.date_type);
        }      
      } else {
        //-- if we didn't find field in item then we add it
        item.fields.push({
          field_id: modelField.element_id,
          element_id: modelField.element_id,
          field_value: getDate(modelField.date_type),
        });
      }
    });
  });
  return items;
}

//******************* GET START DATE *********************//
function getStartDate(dateType) {
  let currentDate = new Date();

  function weekTime(currentDate) {
    var day = currentDate.getDay();
    let numberOfDays;
        if (dateType.includes("week_current,current")) {
          numberOfDays = 0;
        }
        if (dateType.includes("week_next,future")) {
          numberOfDays = 7;
        }
        if (dateType.includes("week_past,past")) {
          numberOfDays = -7;
        }
      let diff = currentDate.getDate() - day + numberOfDays + (day == 0 ? -6:1); 
    return new Date(currentDate.setDate(diff));
  }

  function quarterTime(currentDate) {
        let numberMonths;
        let numberDays;
        let currentQuarter = Math.floor((currentDate.getMonth() / 3));
        let year = currentDate.getFullYear();
        if (dateType.includes("quarter_current,current")) {
          numberMonths = 0;
          numberDays = 0;
        }
        if (dateType.includes("quarter_next,future")) {
          numberMonths = 3;
          numberDays = 0;
        }
        if (dateType.includes("quarter_past,past")) {
          numberMonths = -3;
          numberDays = 0;
        }
      return new Date(year, currentQuarter * 3 + numberMonths, 1 + numberDays);
  }

  switch (dateType) {
    case "week_current,current":           
      return weekTime(new Date()).getTime();

    case "month_current,current":
      return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getTime();

    case "quarter_current,current":       
      return quarterTime(new Date()).getTime();

    case "year_current,current":
      return add(new Date(currentDate.getFullYear(), 0, 1), {years: 0}).getTime();

    case "week_next,future":                
      return weekTime(new Date()).getTime();

    case "month_next,future":
      return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).getTime();

    case "quarter_next,future":
      return quarterTime(new Date()).getTime();

    case "year_next,future":
      return add(currentDate, {days: 0}).getTime();

    case "week_past,past":
      return weekTime(new Date()).getTime();

    case "month_past,past":
      return new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1).getTime();

    case "quarter_past,past":
      return quarterTime(new Date()).getTime();
    
    case "year_past,past":
      return add(currentDate, {years: -1}).getTime();

    case "year_past,past,calendar":
    return add(new Date(currentDate.getFullYear(), 0, 1), {years: -1}).getTime();

    case "year_future,future,calendar":
      return add(new Date(currentDate.getFullYear() + 1, 0, 1), {years: 0}).getTime();

    case "today_current,current":
      return add(currentDate, {days: 0}).getTime();
    
    case "tomorrow,future":
      return add(currentDate, {days: 1}).getTime();
    
    case "7_days_future,future":
      return add(currentDate, {days: 0}).getTime();

    case "10_days_future,future":
      return add(currentDate, {days: 0}).getTime();
    
    case "14_days_future,future":
      return add(currentDate, {days: 0}).getTime();

    case "30_days_future,future":
      return add(currentDate, {days: 0}).getTime();
  
    case "yesterday,past":
      return add(currentDate, {days: -1}).getTime();

    case "7_days_past,past":
      return add(currentDate, {days: -7}).getTime();

    case "10_days_past,past":
      return add(currentDate, {days: -10}).getTime();

    case "14_days_past,past":
      return add(currentDate, {days: -14}).getTime();

    case "30_days_past,past":
      return add(currentDate, {days: -30}).getTime();
  }
}
//********************** GET DATE ************************//
export function getDate(queryKey) {
  var date = new Date();

  function getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + 6 + (day == 0 ? +6:1); 
    return new Date(d.setDate(diff));
  }
  function getNextWeek(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + 13 + (day == 0 ? -6:1);
    return new Date(d.setDate(diff));
  }  
  function getPastWeek(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day - 1 + (day == 0 ? -6:1); 
    return new Date(d.setDate(diff));
  } 

  let currentQuarter = Math.floor((date.getMonth() / 3));
  let year = date.getFullYear();

  switch (queryKey) {
    
    case "next_day":
      return add(date, {days: 1}).getTime();

    case "two_days_after":
      return add(date, {days: 2}).getTime();

    case "three_days_after":
      return add(date, {days: 3}).getTime();

    case "four_days_after":
      return add(date, {days: 4}).getTime();

    case "next_week":
      return add(date, {weeks: 1}).getTime();

    case "two_weeks_after":
      return add(date, {weeks: 2}).getTime();

    case "three_weeks_after":
      return add(date, {weeks: 3}).getTime();
    
    case "this_sunday":
        return setDay(date, 0, {weekStartsOn: 1});
    
    case "this_monday":
        return setDay(date, 1, {weekStartsOn: 1});
    
    case "this_tuesday":
        return setDay(date, 2, {weekStartsOn: 1});
    
    case "this_wednesday":
        return setDay(date, 3, {weekStartsOn: 1});
      
    case "this_thursday":
        return setDay(date, 4, {weekStartsOn: 1});
      
    case "this_friday":
        return setDay(date, 5, {weekStartsOn: 1});

    case "this_saturday":
        return setDay(date, 6, {weekStartsOn: 1});

    case "today_current,current":
      return add(date, {days: 0}).getTime();
    
    case "tomorrow,future":
      return add(date, {days: 1}).getTime();
    
    case "7_days_future,future":
      return add(date, {days: 7}).getTime();

    case "10_days_future,future":
      return add(date, {days: 10}).getTime();
    
    case "14_days_future,future":
      return add(date, {days: 14}).getTime();

    case "30_days_future,future":
      return add(date, {days: 30}).getTime();
    
    case "yesterday,past":
      return add(date, {days: -1}).getTime();

    case "7_days_past,past":
      return add(date, {days: 0}).getTime();

    case "10_days_past,past":
      return add(date, {days: 0}).getTime();

    case "14_days_past,past":
      return add(date, {days: 0}).getTime();

    case "30_days_past,past":
      return add(date, {days: 0}).getTime();

    case "year_future,future,calendar":
      return add(new Date(date.getFullYear() + 1, 0, 0), {years: 1}).getTime();

    case "year_past,past,calendar":
      return add(new Date(date.getFullYear(), 0, 0), {years: 0}).getTime();
      
    case "week_current,current":
      return getMonday(new Date()).getTime();

    case "month_current,current":
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime();

    case "quarter_current,current":     
      return new Date(year, (currentQuarter + 1) * 3, 0).getTime();

    case "year_current,current":
      return add(new Date(date.getFullYear() + 1, 0, 0), {years: 0}).getTime();

    case "week_next,future":             
      return getNextWeek(new Date()).getTime();

    case "month_next,future":
      return new Date(date.getFullYear(), date.getMonth() + 2, 0).getTime();

    case "quarter_next,future":
      return new Date(year, (currentQuarter + 1) * 3 +3, 0).getTime();

    case "year_next,future":
      return add(date, {years: 1}).getTime();

    case "week_past,past": 
    return getPastWeek(new Date()).getTime();

    case "month_past,past":
      return new Date(date.getFullYear(), date.getMonth(), 0, 0).getTime();

    case "quarter_past,past":
      return new Date(year, (currentQuarter + 1) * 3 -3, 0).getTime();

    case "year_past,past":
      return add(date, {days: 0}).getTime();

      case "now":
        default:
          return date.getTime();
  }
}

//********************** CHECK RECURRING DATE ************************//

export function checkRecurringDate(date, option) {

  date = new Date(date);

  let currentDate = new Date();

  switch (option) {
    case 'day':
      if(date.getDate() + '.' + date.getMonth() === currentDate.getDate() + '.' + currentDate.getMonth()) {
        return true;
      } else {
        return false;
      }
    case 'week':
      let currentYear = new Date().getFullYear();
      let shiftedYearDate = new Date(currentYear, date.getMonth(), date.getDate());
      return isSameWeek(shiftedYearDate, currentDate);
    case 'month':
      if(date.getMonth() === currentDate.getMonth()) {
        return true;
      } else {
        return false;
      }
    default:
      return true;
  }
  
}